import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

/** Outlined select that reads as a brand-colored button: icon + label + caret, divider border until hover. */
export const ButtonLikeSelect = styled(Select)(({ theme }) => ({
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightMedium,
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: theme.spacing(1.5),
  },
  '& .MuiSelect-icon': { color: theme.palette.primary.main },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
}));
